// Click-to-play voor embedded video op de Red event-detailpagina.
// Vervangt een poster-afbeelding door een YouTube/Vimeo iframe op klik.
// Privacy-vriendelijk: de embed wordt pas geladen na user-interactie.

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-video-embed-src]');
  if (!trigger) return;

  event.preventDefault();

  var src = trigger.getAttribute('data-video-embed-src');
  if (!src) return;

  var separator = src.indexOf('?') >= 0 ? '&' : '?';
  var iframe = document.createElement('iframe');
  iframe.setAttribute('src', src + separator + 'autoplay=1');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
  iframe.setAttribute('allowfullscreen', 'true');
  iframe.setAttribute('loading', 'lazy');
  iframe.className = 'event-video-embed__iframe';

  trigger.replaceWith(iframe);
});
